export default "__VITE_ASSET__4L8X5Y0W5Xr4aSsV2zlAig__"